<template>
  <div>
    <div class="order-info-block">
      <div class="block-title">商品信息</div>
      <el-table
        :data="orderInfo.detailList"
        :show-header="false"
        border
        class="order-detail"
      >
        <el-table-column label="图片名称" width="400">
          <template slot-scope="scope">
            <el-row>
              <el-col :span="24">
                <div class="item-name">{{ scope.row.itemName }}</div>
                <div>商品编码: {{ scope.row.itemCode }}</div>
                <div>状态: {{ scope.row.detailStatusName }}</div>
              </el-col>
            </el-row>
          </template>
        </el-table-column>

        <el-table-column label="详细信息" width="400">
          <template slot-scope="scope">
            <div>
              <div>品牌: {{ getBrandName(scope.row) }}</div>
              <!-- <div>渠道: {{ getChannelName(scope.row) }}</div>
              <div>渠道类型: {{ scope.row.mmr12TypeName }}</div> -->
              <div>
                mmr12: {{ scope.row.mmr12
                }}<span v-if="scope.row.mmr12Name">-</span
                >{{ scope.row.mmr12Name }}
              </div>
              <div>
                总账科目: {{ scope.row.ledgerAccount
                }}<span v-if="scope.row.ledgerAccountName">-</span
                >{{ scope.row.ledgerAccountName }}
              </div>
              <!-- <div>分类: {{ scope.row.categoryName }}</div> -->
              <div>分类：{{scope.row.pocmDTO.secondCatalogueName}}</div>
              <!-- <div>供应商: {{ scope.row.pocmDTO.produceSupplierName }}</div> -->
              <div v-if="scope.row.supplierDTO && scope.row.supplierDTO.supplierName">供应商：{{ scope.row.supplierDTO.supplierName }}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <div>
              <div>单价(不含税): ￥{{ scope.row.purchasePrice | thousandSymbol}}</div>
              <!-- <div>单位: {{ scope.row.itemUnit }}</div> -->
              <div>数量: {{ scope.row.purchaseQuantity | thousandSymbol}}</div>
              <div>小计: ￥{{ getItemSumPrice(scope.row) | thousandSymbol}}</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="order-info-block order-info-certificate">
      <span class="block-title">比价凭证</span>
      <el-button
        v-if="orderInfo.voucherList && orderInfo.voucherList.length !== 0"
        class="btn-red-plain btn-delete-certificate"
        type="danger"
        plain
        @click="deleteCertificate"
        >删除
      </el-button>
      <el-table
        :data="orderInfo.voucherList"
        :show-header="false"
        border
        @select="selectCertificate"
        class="order-detail"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="比价凭证">
          <template slot-scope="scope">
            <div>
              <div>{{ scope.row.imageName }}</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="order-info-block">
      <span class="block-title">上传比价凭证</span>
      <el-upload
        class="upload-box"
        ref="uploadCertificate"
        :action="fileUploadTarget"
        :headers="uploadHeaders"
        :on-success="handleUploadSuccess"
        :before-remove="handleFileRemove"
        :file-list="fileList"
      >
        <el-button
          class="btn-red-plain btn-upload-certificate"
          type="primary"
          plain
          >上传</el-button
        >
      </el-upload>
      <el-button
        class="btn-red-plain btn-save-certificate"
        type="primary"
        plain
        @click="submitCertificate"
        >保存</el-button
      >
    </div>
  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'
import { create, all } from 'mathjs/number'
import { tokenUtils } from '@/utils/auth'
import { mapState } from 'vuex'
import baseApi from '@/api/base'
const math = create(all)
export default {
  name: 'order-item-info-non-menu',
  props: {
    orderInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    ...mapState({
      fileUploadTarget: state => state.app.fileUploadTarget
    }),
    uploadHeaders () {
      return {
        Authorization: 'Bearer ' + tokenUtils.getToken(true),
        Accept: 'application/json'
      }
    }
  },
  data: () => {
    return {
      fileList: [],
      voucherFileList: [],
      certificateSelectedList: []
    }
  },
  methods: {
    getBrandName (row) {
      if (row.subBrandName) {
        return row.abiBrandName + ' - ' + row.subBrandName
      }
      return row.abiBrandName
    },
    getChannelName (row) {
      if (row.subChannelName) {
        return row.channelName + ' - ' + row.subChannelName
      }
      return row.channelName
    },
    getItemSumPrice (item) {
      if (!item) {
        return ''
      }
      let sum = commonUtils
        .formatNumber(
          math.multiply(
            item.purchasePrice,
            item.purchaseQuantity / item.pocmDTO.priceUnitQuantity
          )
        )
        .toFixed(2)
      sum = Number(sum) ? sum : 0.01
      return sum
    },
    handleUploadSuccess (response, file) {
      if (response.resultCode === '0') {
        this.fileList.push(file)
      } else {
        this.$message.error({ message: response.resultMsg, showClose: true })
        this.fileList.pop()
      }
    },
    handleFileRemove (file) {
      if (file) {
        baseApi
          .deleteFile({ fileId: file.response.resultData.fileDTO.fileId })
          .then(res => {
            if (res.data.resultCode === '0') {
              this.fileList.forEach((item, index) => {
                if (item.uid === file.uid) {
                  this.fileList.splice(index, 1)
                }
              })
            }
          })
      }
    },
    submitCertificate () {
      if (this.fileList.length === 0) {
        this.$message.warning('请上传凭证')
        return
      }
      let params = {
        orderId: this.orderInfo.parentOrderId
          ? this.orderInfo.parentOrderId
          : this.orderInfo.orderId,
        voucherFiles: ''
      }
      if (
        this.orderInfo.voucherList &&
        this.orderInfo.voucherList.length !== 0
      ) {
        this.orderInfo.voucherList.forEach(item => {
          this.voucherFileList.push(item.imageFileId)
        })
      }
      this.fileList.forEach(item => {
        this.voucherFileList.push(item.response.resultData.fileDTO.fileId)
      })
      this.voucherFileList.forEach(item => {
        params.voucherFiles += item + ','
      })
      this.$store.dispatch('updateNonMenuOrder', params).then(res => {
        if (res.data.resultCode === '0') {
          this.$message.success('更新数据成功')
          this.fileList = []
          this.voucherFileList = []
          this.$emit('updateOrder')
        }
      })
    },
    // 删除凭证
    deleteCertificate () {
      if (this.certificateSelectedList.length <= 0) {
        this.$message.error('请选择要删除的凭证')
        return
      }
      let params = {
        orderId: this.orderInfo.parentOrderId
          ? this.orderInfo.parentOrderId
          : this.orderInfo.orderId,
        voucherFiles: ''
      }
      this.setDifferenceVoucher().forEach(item => {
        params.voucherFiles += item + ','
      })
      this.$store.dispatch('updateNonMenuOrder', params).then(res => {
        if (res.data.resultCode === '0') {
          this.$message.success('删除成功')
          this.voucherFileList = []
          params.voucherFiles = ''
          this.$emit('updateOrder')
        }
      })
    },
    selectCertificate (selection, row) {
      this.certificateSelectedList = selection
    },
    // 求凭证差集
    setDifferenceVoucher () {
      let voucherList = []
      let selectedSet = []
      this.orderInfo.voucherList.forEach(item => {
        voucherList.push(item.imageFileId)
      })
      this.certificateSelectedList.forEach(item => {
        selectedSet.push(item.imageFileId)
      })
      selectedSet = new Set(selectedSet)
      let differenceVoucherList = voucherList.filter(
        item => !selectedSet.has(item)
      )
      return differenceVoucherList
    }
  }
}
</script>

<style lang="scss" scoped>
.order-info-block {
  position: relative;
  border-radius: 10px;
  background-color: $base-white;
  padding: 20px;
  margin-bottom: 20px;
  .block-title {
    line-height: 32px;
  }
  .order-detail {
    width: 100%;
    .item-name {
      text-align: left;
      font-weight: 700;
    }
    .item-sum {
      font-weight: 700;
    }
  }
}
.upload-box {
  display: inline;
  margin-left: 30px;
  margin-right: 30px;
}
.order-info-certificate {
  .btn-delete-certificate {
    display: inline-block;
    margin-left: 30px;
    margin-bottom: 10px;
  }
}
.btn-save-certificate {
  position: absolute;
  top: 20px;
  left: 220px;
}
</style>
